// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreateRefundResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_CreateRefundResponseDados {
id: number
pays_to: string
franchise_id: number
title: string
description: string
amount: number
blob_name: string
expense_date: string
request_date: string
accepted_at: string
declined_at: string
status: number
created_at: string
updated_at: string
}

export type Payroll_CreateRefundResponse = ApiResponse<Payroll_CreateRefundResponseDados>;

registerResponseContract('Payroll_CreateRefundResponse', {
  id:           { type: 'number',  required: true },
  pays_to:      { type: 'string',  required: true },
  franchise_id: { type: 'number',  required: true },
  title:        { type: 'string',  required: true },
  description:  { type: 'string',  required: false },
  amount:       { type: 'number',  required: true },
  blob_name:    { type: 'string',  required: false },
  expense_date: { type: 'string',  required: false },
  request_date: { type: 'string',  required: false },
  accepted_at:  { type: 'string',  required: false },
  declined_at:  { type: 'string',  required: false },
  status:       { type: 'number',  required: true },
  created_at:   { type: 'string',  required: false },
  updated_at:   { type: 'string',  required: false },
})
